import React from "react";
import styled from "styled-components";
import Header from "./Header";
import Footer from "../Footer";

const Wrapper = styled.div`
  position: relative;

  main {
    min-height: calc(100vh - var(--header-height) - var(--footer-height));
  }
`;

const Layout = ({ children, showApplyCta, ctaLabel, tagline, footer }: any) => {
  return (
    <Wrapper className="layout">
      {/* Header is a direct child on purpose: it used to sit in a bare wrapper
       * div, and position:sticky only sticks within its own parent — that div
       * was only as tall as the header, so it scrolled straight off. */}
      <Header
        showApplyCta={showApplyCta}
        ctaLabel={ctaLabel}
        tagline={tagline}
      />
      <main>{children}</main>
      {/* pages may supply their own footer; /landing and /landing-2 use the shared one */}
      {footer || <Footer />}
    </Wrapper>
  );
};

export default Layout;
